module.exports = __webpack_public_path__ + "static/media/Invest Atlanta template.77922c85.xlsx";